import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator' // koristiš sada fleksibilnu komponentu
import classesK from '../kalkulatori.module.css'
import { useEffect, useState } from 'react'
import ResultsSection from '../redesign/components/ResultsSection'
import { areAllFieldsFilled } from '../../utils/calculationDataValidation'
import runCalculator from '../api/runCalculator'

// SHARED 2-way margin engine (procene). Map calculatorType -> API slug.
const SLUG_BY_TYPE = {
  Boks: 'boxing',
  Mma: 'mma',
}

const Boks = ({ calculatorType = 'Boks' }) => {
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({
    values: {
      odds: ['', ''],
    },
    results: {
      odds: ['', ''],
    },
  })
  const [showInputArea, setShowInputArea] = useState(true)

  const allInputsFilled = areAllFieldsFilled(data.values)

  useEffect(() => {
    if (allInputsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allInputsFilled])

  const calculateWinningChances = async () => {
    const parsedOdds = Array.isArray(data?.values.odds)
      ? data.values.odds.map((odd) => parseFloat(odd)).filter((odd) => odd > 0)
      : []

    if (parsedOdds.length === 0) {
      console.error(
        'Invalid odds provided. Ensure all odds are greater than zero.'
      )
      return false
    }

    const slug = SLUG_BY_TYPE[calculatorType] || 'boxing'
    const body = {
      oddsPlayer1: parsedOdds[0],
      oddsPlayer2: parsedOdds[1],
    }

    setLoading(true)
    setError(false)
    try {
      const res = await runCalculator('predictions', slug, body)
      setData((prevData) => ({
        ...prevData,
        results: {
          odds: [res.fighter1WinPct, res.fighter2WinPct],
        },
      }))
      return true
    } catch (err) {
      setError(true)
      return false
    } finally {
      setLoading(false)
    }
  }

  const clearFields = () => {
    setData({
      values: {
        odds: ['', ''],
      },
      results: {
        odds: ['', ''],
      },
    })
    setError(false)
    setShowInputArea((prev) => !prev)
  }

  const handleButtonClick = async () => {
    if (!showInputArea) {
      clearFields()
      setDisabled(true)
      return
    }
    const ok = await calculateWinningChances()
    if (ok) {
      setShowInputArea((prev) => !prev)
    }
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={handleButtonClick} disabled={disabled || loading}>
            {loading
              ? 'Obračun u toku...'
              : showInputArea
              ? 'Prikaži rezultate'
              : 'Unesi obračunske podatke'}
          </button>
        </div>

        {error && (
          <div className={classesK.sectionTitle}>
            Greška pri obračunu, pokušajte ponovo.
          </div>
        )}

        {showInputArea && (
          <>
            <div className={classesK.sectionTitle}>
              Upiši kvote za ishod utakmice
            </div>
            <OddsCalculator
              data={data.values}
              field={'odds'}
              setData={setData}
              labelPrefix={['KI 1', 'KI 2']}
              type={['number', 'number']}
              step={['0.1', '0.1']}
              min={['0.1', '0.1']}
              setError={setError}
              rows={2}
            />
          </>
        )}
        {!showInputArea && (
          <>
            <div className={classesK.sectionResults}>
              <ResultsSection
                title={`Ishod utakmice`}
                subtitle={`Konačan ishod`}
                withPercent={true}
                results={data?.results?.odds.map((result) => `${result}%`)}
                names={['KI 1', 'KI 2']}
              />
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Boks
